import request from '@/utils/request'
import { getRequest } from "@/utils/postData";
// 列表
export function getList(params) {
    var sign = getRequest(params);
    return request({
        url: '/v4/first_page_infos',
        method: 'get',
        params: {
            per: params.per,
            page: params.page
        },
        headers: {
            'X-Signature': sign
        }
    })
}
// 轮播图
export function getBanner(params) {
    var sign = getRequest(params);
    return request({
        url: '/v4/banners',
        method: 'get',
        params: {
            category: params.category
        },
        headers: {
            'X-Signature': sign
        }
    })
}
// 广告图
export function getAdvertise(params) {
    return request({
        url: '/v3/fetch_creative',
        method: 'get',
        params: {
            fetchtype: params.fetchtype,
            bidrequest: params.bidrequest
        }
    })
}
// 热门文章
export function getHotArticle() {
    var sign = getRequest({});
    return request({
        url: '/v4/articles/top',
        method: 'get',
        headers: {
            'X-Signature': sign
        }
    })
}
// 热门标签
export function getHotLaber() {
    var sign = getRequest({});
    return request({
        url: '/v4/topics/top',
        method: 'get',
        headers: {
            'X-Signature': sign
        }
    })
}
// 本月杂志新上架
export function getMagazines() {
    var sign = getRequest({});
    return request({
        url: '/v4/magazines/top',
        method: 'get',
        headers: {
            'X-Signature': sign
        }
    })
}
// 热门音频
export function getHotAudio() {
    var sign = getRequest({});
    return request({
        url: '/v4/audio_series/top',
        method: 'get',
        headers: {
            'X-Signature': sign
        }
    })
}
// 修改昵称
export function getEditName(data) {
    var sign = getRequest(data);
    return request({
        url: `/v4/users/${data.id}`,
        method: 'patch',
        data,
        headers: {
            'X-Signature': sign
        }
    })
}

// 首页昨日今晨
export function getNewsWeek() {
    var sign = getRequest({});
    return request({
        url: 'v4/first_page_infos/audioNewsWeek',
        method: 'get',
        headers: {
            'X-Signature': sign
        }
    })
}



// WEBPACK FOOTER //
// ./src/api/home.js